export const BUILDWISE_MODULES = {
  HOME: 'Home',
  COLLECTIONS: 'Collections',
  PROCEDURES: 'Procedures',
  PARTNERS: 'Partners',
  PROJECTS: 'Projects',
  INSIGHTS: 'Insights',
  RETROSPECTIVES: 'Retrospectives',
  HELP_CENTER: 'Help Center',
  TRACKERS: 'Trackers',
};

export const BUILDWISE_MODULES_FEATURES = {
  HOME: {
    TEMPLATES_FOR_POSTS: 'Templates for Posts',
    SHARE_KNOWLEDGE: 'Share Knowledge',
    ASK_PEERS: 'Ask Peers',
    SUGGEST_IMPROVEMENTS: 'Suggest Improvements',
    REQUEST_A_POST: 'Request a Post',
    CHAT_WITH_AI: 'Chat with AI',
    SUMMARIZE_SEARCH_RESULTS: 'Summarize Search Results',
    SUMMARIZE_LEARNINGS: 'Summarize Learnings',
    SUMMARIZE_FORM_WITH_AI: 'Summarize with AI',
    MAKE_A_POST: 'MAKE_A_POST',
    WRITE_MANUALLY: 'Write it Yourself',
    WRITE_WITH_AI: 'Write with AI',
    PARSE_FILE: 'Summarize from File',
    WE_WILL_WRITE: 'We will Write',
    NOTES: 'Notes',
  },
  PROJECTS: {
    FILES: 'Files',
    PROGRESS_CARDS: 'Progress Cards',
    SCORECARDS: 'Scorecards',
    ADD_SCORECARDS: 'Add Scorecards',
    ACTIVITY_LOG: 'Activity Log',
  },
  PARTNERS: {
    SCORECARDS: 'Scorecards',
    ADD_SCORECARDS: 'Add Scorecards',
  },
};
